"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductsServiceCallListTransformed;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _useProductsServiceCallList = _interopRequireDefault(require("../useProductsServiceCallList"));

var _usePopulateProductHref = _interopRequireDefault(require("../../app/AppSettingsProvider/usePopulateProductHref"));

// import useProductsServiceCallList from '@sprinx/react-products/useProductsServiceCallList';
function useProductsServiceCallListTransformed(options, currency, // backward compatibility issue
initialFilter, initialOrder, initialPagination) {
  var populateProductHref = (0, _usePopulateProductHref.default)();
  var serviceCallResult = (0, _useProductsServiceCallList.default)(options, initialFilter, initialOrder, initialPagination);

  var transformResult = function transformResult(r) {
    return r && Array.isArray(r.rows) ? (0, _extends2.default)({}, r, {
      rows: populateProductHref(r.rows)
    }) : (0, _extends2.default)({}, r, {
      rows: []
    });
  };

  return Array.isArray(serviceCallResult) ? function (_ref) {
    var _ref2 = (0, _toArray2.default)(_ref),
        r = _ref2[0],
        other = _ref2.slice(1);

    return [transformResult(r)].concat((0, _toConsumableArray2.default)(other));
  }(serviceCallResult) : function () {
    return serviceCallResult.apply(void 0, arguments).then(transformResult);
  };
}